import { createVNode as _createVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/diamond_green.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-4b8d7562")

_pushScopeId("data-v-4b8d7562")
const _hoisted_1 = { class: "text-center" }
const _hoisted_2 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "mt-4 mb-2"
}, null, -1)
const _hoisted_3 = { class: "page_padding" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_localized_text = _resolveComponent("localized-text")
  const _component_premium_service = _resolveComponent("premium-service")
  const _component_full_horizontal_scroll = _resolveComponent("full-horizontal-scroll")
  const _component_countdown = _resolveComponent("countdown")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _hoisted_2,
      _createVNode(_component_localized_text, {
        type: "h1",
        localizedKey: "app_PremiumAttivo",
        text: "Premium Attivo",
        class: "text-uppercase fw_800"
      })
    ]),
    _createVNode(_component_full_horizontal_scroll, {
      class: ["mt-4", _ctx.premiumModel.includedServices.length == 1 ? 'flex_centered' : '']
    }, {
      default: _withId(() => [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.premiumModel.includedServices, (service) => {
          return (_openBlock(), _createBlock(_component_premium_service, {
            class: "me-3 mini",
            premiumService: service
          }, null, 8, ["premiumService"]))
        }), 256))
      ]),
      _: 1
    }, 8, ["class"]),
    _createVNode("div", _hoisted_3, [
      _createVNode(_component_countdown, {
        endDate: _ctx.endDate,
        onCountdownEnded: _ctx.refresh
      }, null, 8, ["endDate", "onCountdownEnded"])
    ])
  ], 64))
})